export const ACCESS_TOKEN = process.env.ACCESS_TOKEN_NAME || "ggp_accessToken";
export const REFRESH_TOKEN =
  process.env.REFRESH_TOKEN_NAME || "ggp_refreshToken";
export const PROFILE_ID = process.env.PROFILE_ID_NAME || "ggp_profileId";

export const login = async (
  accessToken: string,
  refreshToken: string,
  callback?: Function
) => {
  localStorage.setItem(ACCESS_TOKEN, accessToken);
  localStorage.setItem(REFRESH_TOKEN, refreshToken);
  if (callback) {
    callback();
  }
};

export const writeAccessToken = async (accessToken: string) => {
  localStorage.setItem(ACCESS_TOKEN, accessToken);
};

export const writeRefreshToken = async (refreshToken: string) => {
  localStorage.setItem(REFRESH_TOKEN, refreshToken);
};

export const readAccessToken = () => {
  return localStorage.getItem(ACCESS_TOKEN);
};

export const readRefreshToken = () => {
  return localStorage.getItem(REFRESH_TOKEN);
};

export const deleteAccessToken = () => {
  return localStorage.removeItem(ACCESS_TOKEN);
};

export const deleteRefreshToken = () => {
  return localStorage.removeItem(REFRESH_TOKEN);
};

export const readProfileId = () => {
  return localStorage.getItem(PROFILE_ID);
};

export const deleteProfileId = () => {
  return localStorage.removeItem(PROFILE_ID);
};

export const getUserInfo = () => {
  const localStorageUser: string | null =
    localStorage.getItem("recoil-persist");
  if (localStorageUser) {
    const storageJson = JSON.parse(localStorageUser);
    return storageJson["user"];
  }

  return null;
};

export const logout = () => {
  localStorage.removeItem(ACCESS_TOKEN);
  localStorage.removeItem(REFRESH_TOKEN);
  localStorage.removeItem(PROFILE_ID);
  window.location.href = "/";
};

export const validateToken = async () => {};
